define(['angular', 'underscore'], function (angular, _) {
    'use strict';

    return (
        angular
            .module('errorHandlerService', [])
            // Global service for error handling
            .factory('ErrorHandler', function () {
                return {
                    // Get the user-facing error message out of a Symfony error response
                    getMessage: function (
                        response,
                        defaultMessage // Allow callers to provide a default in case the response object doesn't have error text
                    ) {
                        // Only pass through
                        var errors = [];
                        if (_.isArray(response)) {
                            errors = response;
                        } else if (
                            response.data &&
                            response.data.error &&
                            response.data.error.details
                        ) {
                            errors = response.data.error.details;
                            try {
                                errors = JSON.parse(errors);
                            } catch (e) {
                                errors = [errors];
                            }
                        } else if (defaultMessage) {
                            errors = [defaultMessage];
                        } else if (response.statusText) {
                            errors = [response.statusText];
                        } else {
                            errors = ['An unknown error occured.'];
                        }

                        // Make sure there are no exact duplicates, because ng-repeat doesn't like that
                        errors = errors.filter(function (e, i, arr) {
                            return errors.lastIndexOf(e) === i;
                        });

                        return errors;
                    },
                };
            })
    );
});
